import { useTranslation } from 'react-i18next';
import { ConfirmationModal } from '@airclou/ui';
import type { CompanyMember } from '@/api/groups';

interface DeleteMemberModalProps {
  member: CompanyMember;
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isLoading?: boolean;
}

export function DeleteMemberModal({ member, isOpen, onClose, onConfirm, isLoading }: DeleteMemberModalProps) {
  const { t } = useTranslation('dashboard');

  return (
    <ConfirmationModal
      isOpen={isOpen}
      onClose={onClose}
      title={
        <div style={{ wordBreak: 'break-word', overflowWrap: 'break-word', maxWidth: '300px' }}>
          {t('people.removeMemberTitle', { email: member.email })}
        </div>
      }
      variant="danger"
      confirmText={t('people.removeMember')}
      onConfirm={onConfirm}
      isLoading={isLoading}
      description={
        <div className="space-y-3">
          <p>{t('people.removeMemberWill')}</p>
          <ul className="list-disc pl-5 space-y-1 text-sm">
            <li>{t('people.removeMemberFromCompany', { email: member.email })}</li>
            <li>{t('people.revokeWorkspaceAccess')}</li>
            <li>{t('people.deleteGroupMembership')}</li>
          </ul>
          <p className="font-medium">{t('common.actionCannotBeUndone')}</p>
        </div>
      }
    />
  );
}
